function formatCurrency(n: number): string {
  if (n > 1000000000) {
    return Math.floor(n / 10000000) / 100 + " Mrd."
  } else if (n > 1000000) {
    return Math.floor(n / 10000) / 100 + " Mio."
  } else {
    return Intl.NumberFormat("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 6 })
      .format(n)
      .replaceAll("’", "'")
      .replace(",", ".")
  }
}

export { formatCurrency }
